<template>
    <div>
        <div v-if="erro">
            <SemPermissao></SemPermissao>
        </div>
        <template v-if="!erro">
            <FormularioForm :formulario="null" />
        </template>
    </div>
</template>

<script>

    import FormularioForm from '../../components/formularios/FormularioForm.vue';
    import SemPermissao from "../SemPermissao.vue"

    export default {
        name: "FormularioNew",
        data() {
            return {
                erro: false,
            };
        },
        components: {
            SemPermissao,
            FormularioForm,
        },
    };
</script>

<style lang="scss" scoped>
</style>